
import { ObjectUpdate } from '../../../concepts/objects';
import { CreatePhysicalToolBehavior2 } from '../../canvas/tooling/CreatePhysicalToolBehavior2';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { ToolSettings } from '../../canvas/tooling/ToolBehavior';
import { ColorList } from './../../../ui';
import { TaskCard } from './TaskCard';

class CreateTaskCardToolBehavior extends CreatePhysicalToolBehavior2(TaskCard) {

    public init(settings: ToolSettings, param: string) {
        param = param || 'plop:edit';
        return super.init(settings, param);
    }

    protected createSubject(u: ObjectUpdate) {
        const subject = super.createSubject(u);
        subject.color = this.settings.color ?? ColorList[3];
        return subject;
    }

}

export const taskCardTool = defineToolWithCommonBehaviors({
    id: 'taskCardTool',
    label: 'Task Cards',
    category: 'collaboration',
    icon: 'deqo://icons/d2/task-card',
    weight: 1021,
    // shortcut: '',
    behaviors: [CreateTaskCardToolBehavior]
});
